import { useCallback, useState, useContext, useEffect } from "react";
import {
  getOrganizationAppLinks,
  addOrganizationAppLinks,
  deleteOrganizationAppLinks,
} from "./Services/AdvanceSettingService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom";

const OrgAppLink = () => {
  const [columns, setColumns] = useState(["App Name", "Link", "Logo"]); // Columns state
  const [rows, setRows] = useState([{}]); // Rows state
  const [editIndex, setEditIndex] = useState(null);
  const { GUID } = useParams();
  const [orgAppLinkList, setOrgAppLinkList] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  const [orgAppId, setOrgAppId] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  let toster = useContext(TostMsg);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({
    AppName: "",
    Link: "",
    Logo: "",
  });
  let SearchValue = "";

  useEffect(() => {
    GetOrgAppLink();
  }, []);

  const validateOrgAppLink = (data, index) => {
    const newErrors = {};
    newErrors[`${index}-AppName`] =
      !data.AppName || data.AppName.trim() === ""
        ? "AppName  is required"
        : undefined;
    newErrors[`${index}-Link`] =
      !data.Link || data.Link.trim() === "" ? "Link is required" : undefined;
    newErrors[`${index}-Logo`] =
      !data.Logo || data.Logo.trim() === "" ? "Logo is required" : undefined;
    setErrors((prev) => ({ ...prev, ...newErrors }));
    const isValid = Object.values(newErrors).every(
      (error) => error === undefined
    );
    return isValid;
  };

  async function GetOrgAppLink() {
    setIsloading(true);
    try {
      let responce = await getOrganizationAppLinks({});
      setOrgAppLinkList(responce?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setIsloading(false);
    }
  }

  const handleAddRow = () => {
    setOrgAppLinkList([...orgAppLinkList, { AppName: "", Link: "", Logo: "" }]);
    setEditIndex(orgAppLinkList.length);
  };

  const handleRemoveRow = () => {
    setRows(rows.slice(0, -1));
  };

  const handleRemoveSpecificRow = (rowIdx) => () => {
    const updatedRows = rows.filter((_, idx) => idx !== rowIdx);
    setRows(updatedRows);
  };

  const handleChange = (rowIdx, colName) => (e) => {
    const { value } = e.target;
    setOrgAppLinkList((prevList) => {
      const newList = prevList.map((item, idx) =>
        idx === rowIdx ? { ...item, [colName]: value } : item
      );
      return newList;
    });
    setData((prev) => ({ ...prev, [colName]: value }));
    validateOrgAppLink({ ...orgAppLinkList[rowIdx], [colName]: value }, rowIdx);
  };

  const cancelOrgWfh = () => {
    GetOrgAppLink();
    setOrgAppLinkList((prevList) => {
      setEditIndex(null);
      const len = prevList.length;
      if (len === 0) return prevList;

      const lastItem = prevList[len - 1];
      const isEmpty =
        lastItem && !lastItem.AppName && !lastItem.Link && !lastItem.Logo;
      if (isEmpty) {
        return prevList.slice(0, -1);
      }
      return prevList;
    });
  };

  async function addOrgAppLinks(index, data) {
    const appNameToCheck = data.AppName?.trim().toLowerCase();
    const isDuplicate = orgAppLinkList.some(
      (app, idx) =>
        idx !== index &&
        app.AppName &&
        app.AppName.trim().toLowerCase() === appNameToCheck
    );

    if (isDuplicate) {
      toster.current.warn("This app already exists in the list.");
      return;
    }

    const body = {
      Id: data?.Id || 0,
      GUID: GUID,
      IsActive: true,
      CreatedDate: data.CreatedDate || new Date().toISOString(),
      ModifiedDate: new Date().toISOString(),
      CreatedBy: 0,
      ModifiedBy: 0,
      OrgId: 0,
      AppName: data.AppName,
      Link: data.Link,
      Logo: data.Logo,
    };

    try {
      const res = await addOrganizationAppLinks(body);
      if (res?.StatusCode === 2999) {
        toster.current.warn("App already exists on the server.");
        return;
      }
      alert(orgAppId ? "Org App Updated" : "Org App Added");
      setOrgAppLinkList([]);
      setEditIndex(null);
      GetOrgAppLink();
      setIsloading(false);
    } catch (err) {
      const errorCode = err?.response?.data?.StatusCode;
      if (errorCode === 2999) {
        toster.current.warn("App already exists on the server.");
      } else {
        toster.current.error(ERROR_LIST.DefaultError);
      }
      setIsloading(false);
    }
  }

  const handleEditClick = (index) => {
    setEditIndex(index);
  };

  const handleApplstDelete = (Id) => {
    setOrgAppId(Id);
  };

  async function DeleteOrgApp() {
    setIsloading(true);
    if (orgAppId) {
      let body = {
        Id: orgAppId,
      };
      try {
        let orgAppDeleteList = await deleteOrganizationAppLinks(body);
        if (orgAppDeleteList) {
          setIsloading(false);
          GetOrgAppLink();
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      SearchValue = value;
      let filteredList = orgAppLinkList.filter((orgAppLink) =>
        orgAppLink.AppName?.toLowerCase().includes(SearchValue?.toLowerCase())
      );
      if (SearchValue != "") {
        setOrgAppLinkList(filteredList);
      } else {
        GetOrgAppLink();
      }
    }, 800),
    [orgAppLinkList]
  );

  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4"></div>
        <div className="title-text">
          <h3>App Link Types({orgAppLinkList?.length})</h3>
          <div className="d-flex">
            <InputText
              name="requestTitle"
              className="form-control search-grpname me-2"
              onChange={handleInputChange}
              placeholder="Search"
            />
            {!editIndex && (
              <button
                className="addaward-btn"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-bs-original-title=""
                fdprocessedid="izng1j"
                onClick={handleAddRow}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                </svg>
                App
              </button>
            )}
          </div>
        </div>
        <div className="col-md-12 column">
          <table className="table table-bordered table-hover" id="tab_logic">
            <thead>
              <tr>
                {columns.map((colName, colIdx) => (
                  <th key={colIdx} className="text-left">
                    {colName}
                  </th>
                ))}
                <th className="text-left" style={{ width: "100px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {orgAppLinkList?.map((data, index) => (
                <tr key={index}>
                  {editIndex === index ? (
                    <>
                      <td>
                        <input
                          type="text"
                          value={data.AppName}
                          onChange={handleChange(index, "AppName")}
                          placeholder="App Name"
                          className={`form-control ${
                            errors[`${index}-AppName`] ? "is-invalid" : ""
                          }`}
                        />
                        {errors[`${index}-AppName`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-AppName`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="url"
                          value={data.Link}
                          onChange={handleChange(index, "Link")}
                          placeholder="Link (https://example.com)"
                          pattern="https?://.+"
                          className={`form-control ${
                            errors[`${index}-Link`] ? "is-invalid" : ""
                          }`}
                        />
                        {errors[`${index}-Link`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-Link`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          value={data.Logo}
                          onChange={handleChange(index, "Logo")}
                          placeholder="Logo"
                          className={`form-control ${
                            errors[`${index}-Logo`] ? "is-invalid" : ""
                          }`}
                        />
                        {errors[`${index}-Logo`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-Logo`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <>
                          <img
                            onClick={() => {
                              cancelOrgWfh();
                            }}
                            src="/images/org-img/profile/close.png"
                            title="Cancel"
                            className="editactions me-2"
                            style={{ width: "17px" }}
                          />
                          <img
                            src="/images/org-img/profile/check.png"
                            title="Confirm"
                            className="editactions"
                            style={{ width: "17px" }}
                            onClick={() => {
                              if (validateOrgAppLink(data, index)) {
                                addOrgAppLinks(index, data);
                                setEditIndex(null);
                              }
                            }}
                          />
                        </>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{data?.AppName}</td>

                      <td>
                        {data.Link ? (
                          <Link to={data.Link} className="form-control">
                            {data.Link}
                          </Link>
                        ) : (
                          <span className="text-muted">No link provided</span>
                        )}
                      </td>
                      <td>{data?.Logo}</td>
                      <td className="">
                        <button
                          disabled={editIndex != null}
                          className="editactions me-2"
                          onClick={() => handleEditClick(index)}
                        >
                          <img
                            src="/images/tickets/edit-ico.svg"
                            className=""
                            title="Edit"
                          />
                        </button>
                        <button
                          className="editactions"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-org-app"
                          onClick={() => {
                            handleApplstDelete(data?.id);
                            // GetMasterSystemAlertList("Delete_Award", 1);
                          }}
                        >
                          <img
                            src="/images/tickets/delete.svg"
                            className=""
                            title="Delete"
                          />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal fade " id="delete-org-app">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                {/* <p>{deleteContent}</p> */}
                <p>Do you really want to delete this App Link?</p>
                <p></p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => DeleteOrgApp()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrgAppLink;
